import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

export default function Nameplates() {
  const { t } = useLang();
  return (
    <section data-testid="nameplates-section" className="border-b border-black bg-[#F4F4F1] py-14" aria-label="Organizations served">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          data-testid="nameplates-line"
          className="font-heading font-bold tracking-tight text-xl sm:text-2xl text-foreground max-w-3xl mx-auto leading-relaxed"
        >
          {t("nameplates.label")}
        </motion.p>
      </div>
    </section>
  );
}
